import orderBy from "lodash/orderBy";

import { PREDEFINED_MENU_ITEMS } from "@constants/menu";
import {
  SINGLE_LEVEL_MENU_THRESHOLD,
  OTHERS_CATEGORY_CODE,
  TABLET_SINGLE_LEVEL_MENU_THRESHOLD,
  SECOND_LEVEL_MENU_THRESHOLD,
  TABLET_SECOND_LEVEL_MENU_THRESHOLD,
} from "@components/store/multi-level-menu/constants";
import { ALL_SUBCATEGORY_CODE } from "@constants/routes";

const getLevelMenuThreshold = ({ level, isTabletDevice }) => {
  if (level === 1) {
    return isTabletDevice ? TABLET_SINGLE_LEVEL_MENU_THRESHOLD : SINGLE_LEVEL_MENU_THRESHOLD;
  }
  return isTabletDevice ? TABLET_SECOND_LEVEL_MENU_THRESHOLD : SECOND_LEVEL_MENU_THRESHOLD;
};

export const getModifiedMenuList = ({
  list = [],
  parentItemCode = "",
  level = 1,
  parent,
  isPreviewCatalogMode,
  isMultiLevelMenu,
  totalLevel,
  isTabletDevice = false,
  forDynamicSlices = false,
}) => {
  const getMenuList = ({ list = [], parentItemCode = "", level = 1, parent }) => {
    const levelMenuThreshold = getLevelMenuThreshold({ level, isTabletDevice });

    const isMultiLevelMenuListingRequired = list.length - levelMenuThreshold >= 2;

    const isLastParent = isMultiLevelMenu && totalLevel - 1 === level;

    if (isPreviewCatalogMode) {
      list = orderBy([...list], "forSwag");
    }

    //If children appear inside the dropdown, there is no need to display the "others" category.
    if (
      isMultiLevelMenuListingRequired &&
      (!isMultiLevelMenu || totalLevel !== level) &&
      parent !== OTHERS_CATEGORY_CODE &&
      !forDynamicSlices
    ) {
      list = [
        ...list.slice(0, levelMenuThreshold),
        {
          name: "More...",
          code: OTHERS_CATEGORY_CODE,
          children: list.slice(levelMenuThreshold, list.length),
        },
      ];
    }

    return list.reduce((serializedList, data) => {
      const { code, children, isDummyStoreMerch } = data;

      const item = {
        parentItemCode: parentItemCode || data.code,
        itemCode: parentItemCode ? data.code : ALL_SUBCATEGORY_CODE,
        ...data,
      };

      // Add "All Item" as a subcategory if it appears inside the dropdown.
      let updatedChildren =
        (level !== 2 || children?.length > 1) &&
        children?.length &&
        data.code !== OTHERS_CATEGORY_CODE &&
        !forDynamicSlices &&
        !data.themeCollection
          ? [
              {
                ...data,
                children: [],
                name: "All Products",
                parentItemCode: isLastParent ? data?.parent?.code : data.code,
                code: isLastParent ? data.code : ALL_SUBCATEGORY_CODE,
              },
              ...children,
            ]
          : children;

      // Remove children if the item is predefined or a isDummyStoreMerch
      if (PREDEFINED_MENU_ITEMS.includes(code) || isDummyStoreMerch) {
        updatedChildren = [];
      }

      let updatedParentItemCode = parentItemCode ? `${parentItemCode}--${item.code}` : item.code;

      // Recursively process children with updated parameters
      item.children = getMenuList({
        list: updatedChildren,
        parentItemCode: item.code === OTHERS_CATEGORY_CODE ? parentItemCode : updatedParentItemCode,
        level: item.code === OTHERS_CATEGORY_CODE ? level : level + 1,
        parent: data.code,
      });

      serializedList.push(item);
      return serializedList;
    }, []);
  };

  return getMenuList({
    list,
    parentItemCode,
    level,
    parent,
  });
};

//For Mobile
export const getResponsiveModifiedMenuList = ({
  list = [],
  parentItemCode = "",
  level = 1,
  totalLevel,
  isPreviewCatalogMode,
  isMultiLevelMenu,
}) => {
  const isLastParent = isMultiLevelMenu && totalLevel - 1 === level;

  if (isPreviewCatalogMode) {
    list = orderBy([...list], "forSwag");
  }

  return list.reduce((serializedList, data) => {
    const { code, children, isDummyStoreMerch } = data;

    const item = {
      parentItemCode: parentItemCode || data.code,
      itemCode: parentItemCode ? data.code : ALL_SUBCATEGORY_CODE,
      ...data,
    };

    // Add "All Item" as a subcategory if it appears inside the dropdown.
    let updatedChildren =
      (level !== 2 || children?.length > 1) && children?.length
        ? [
            {
              ...data,
              children: [],
              name: "All Products",
              parentItemCode: isLastParent ? data?.parent?.code : data.code,
              code: isLastParent ? data.code : ALL_SUBCATEGORY_CODE,
            },
            ...children,
          ]
        : children;

    // Remove children if the item is predefined or a isDummyStoreMerch
    if (PREDEFINED_MENU_ITEMS.includes(code) || isDummyStoreMerch) {
      updatedChildren = [];
    }

    // Recursively process children with updated parameters
    item.children = getResponsiveModifiedMenuList({
      list: updatedChildren,
      parentItemCode: `${parentItemCode ? `${parentItemCode}--` : ""}${item.code}`,
      level: level + 1,
      totalLevel,
      isPreviewCatalogMode,
      isMultiLevelMenu,
    });

    serializedList.push(item);
    return serializedList;
  }, []);
};
